import CollectionFilterPc from "../snippets/collection-filter-pc";
import CollectionFilterSp from "../snippets/collection-filter-sp";
import CollectionGridHeader from "../snippets/collection-grid-header";
import CollectionGridBrandHeader from "../snippets/collection-grid-brand-header";
import CollectionGridLoadMore from "../snippets/collection-grid-load-more";
import FilterParamsUtil from "./collection-grid/filter-params-util";
import QueryProducts from "./collection-grid/query-products";
import ProductsRenderer from "./collection-grid/products-renderer";

const KEY = "fs-collection-grid-scroll-position";

const CollectionGrid = (el, sectionParams) => {
  let scrollRestored = true;
  let filterParams = null;
  let collectionFilterPc = null;
  let collectionFilterSp = null;
  let collectionGridHeader = null;
  let collectionGridLoadMore = null;
  let debounceId = null;
  let lastResult = null;

  const initialize = () => {
    document.addEventListener("click", function (e) {
      const link = e.target.closest('a[href*="/products/"]');
      if (link) {
        sessionStorage.setItem(KEY, window.scrollY);
      }
    });
    let needsScrollRestore = false;
    const navEntries = performance.getEntriesByType("navigation");
    if (navEntries.length) {
      const navType = navEntries[0].type;
      if (navType === "back_forward") {
        needsScrollRestore = true;
        scrollRestored = false;
      }
    }
    const collectionFilterPcEl = el.querySelector(".fs-collection-filter-pc");
    if (collectionFilterPcEl) {
      collectionFilterPc = CollectionFilterPc(
        collectionFilterPcEl,
        sectionParams,
        handleChangeFilterParams,
        handleSubmit,
      );
    }
    const collectionFilterSpEl = el.querySelector(".fs-collection-filter-sp");
    if (collectionFilterSpEl) {
      collectionFilterSp = CollectionFilterSp(collectionFilterSpEl, sectionParams, handleChangeFilterParams);
    }
    const collectionGridHeaderEl = el.querySelector(".fs-collection-grid-header");
    if (collectionGridHeaderEl) {
      collectionGridHeader = CollectionGridHeader(
        collectionGridHeaderEl,
        sectionParams,
        handleChangeFilterParams,
        () => {
          collectionFilterSp?.show(filterParams);
        },
      );
    }
    const collectionGridBrandHeaderEl = el.querySelector(".fs-collection-grid-brand-header");
    if (collectionGridBrandHeaderEl) {
      CollectionGridBrandHeader(collectionGridBrandHeaderEl);
    }

    const collectionGridLoadMoreEl = el.querySelector(".fs-collection-grid-load-more");
    if (collectionGridLoadMoreEl) {
      collectionGridLoadMore = CollectionGridLoadMore(
        collectionGridLoadMoreEl,
        sectionParams,
        handleChangeFilterParams,
      );
    }

    const newFilterParams = FilterParamsUtil.createFromCurrentLocation();
    if (needsScrollRestore) {
      loadToRestoreScrollPosition(newFilterParams, 1);
    } else {
      handleChangeFilterParams(newFilterParams);
    }
  };

  const handleSubmit = () => {
    // handleChangeFilterParams([...filterParams]);
  };

  const loadToRestoreScrollPosition = (newFilterParams, page) => {
    const currentPage = FilterParamsUtil.currentPage(newFilterParams);
    if (page == currentPage) {
      handleChangeFilterParams(newFilterParams);
      return;
    }
    const pageFilterParams = [...newFilterParams.filter((fp) => fp.key != "page"), { key: "page", value: page }];
    QueryProducts.run(lastResult, pageFilterParams, sectionParams, (result) => {
      lastResult = result;
      loadToRestoreScrollPosition(newFilterParams, page + 1);
    });
  };

  const updateOtherItemVisible = () => {
    const otherContainerEl = el.querySelector("#fs-collection-grid-items-other-container");
    const loadMoreEl = el.querySelector(".fs-collection-grid-load-more.show");
    if (loadMoreEl) {
      otherContainerEl.style.display = "none";
      return;
    }
    const nItems = otherContainerEl.querySelectorAll(".fs-collection-grid-item").length;
    if (nItems <= 0) {
      otherContainerEl.style.display = "none";
      return;
    }
    otherContainerEl.style.display = "block";
  };

  const handleChangeFilterParams = (newFilterParams) => {
    if (filterParams != newFilterParams) {
      if (filterParams != null) {
        newFilterParams = FilterParamsUtil.updateSortType(newFilterParams);
        newFilterParams = FilterParamsUtil.removePageParamsIfNeed(filterParams, newFilterParams);
      }
      const currentPage = FilterParamsUtil.currentPage(newFilterParams);
      if (currentPage != 1 && (!lastResult || lastResult.products.length <= 0)) {
        newFilterParams = newFilterParams.filter((fp) => fp.key != "page");
      }
      filterParams = newFilterParams;
      collectionFilterPc?.setFilterParams(filterParams);
      collectionGridLoadMore.setFilterParams(filterParams);
      if (collectionGridHeader) {
        const headerDetailText = FilterParamsUtil.headerDetailText(filterParams, sectionParams);
        collectionGridHeader.setHeaderDetailText(headerDetailText);
        collectionGridHeader.setFilterParams(filterParams);
      }
      if (debounceId) {
        clearTimeout(debounceId);
      }
      debounceId = setTimeout(() => {
        debounceId = null;
        QueryProducts.run(
          lastResult,
          filterParams,
          sectionParams,
          (result) => {
            FilterParamsUtil.pushHistory(filterParams);
            const containerEl = el.querySelector("#fs-collection-grid-items");
            const noResultEl = el.querySelector(".fs-collection-grid-no-results");
            ProductsRenderer.run(result, containerEl, noResultEl);
            collectionGridLoadMore.setResult(result);
            updateOtherItemVisible();
            lastResult = result;

            if (!scrollRestored) {
              scrollRestored = true;
              setTimeout(() => {
                const strTop = sessionStorage.getItem(KEY) ?? "0";
                window.scrollTo({ top: parseInt(strTop), behavior: "instant" });
              }, 100);
            }
          },
          (otherResult) => {
            const containerEl = el.querySelector("#fs-collection-grid-items-other");
            ProductsRenderer.run(otherResult, containerEl, null);
            updateOtherItemVisible();
          },
        );
      }, 800);
    }
  };

  initialize();

  return {};
};

/*
 * Main
 */

document.addEventListener("DOMContentLoaded", () => {
  if (!location.pathname.startsWith("/collections/")) {
    return;
  }
  const el = document.querySelector(".section-collection-grid");
  const sectionParams = window.fstore.sections.find((section) => section.id == el.id.replace("shopify-section-", ""));
  const collectionGrid = CollectionGrid(el, sectionParams);
});

window.addEventListener("pageshow", (e) => {
  if (e.persisted) {
    setTimeout(() => {
      const strTop = sessionStorage.getItem(KEY) ?? "0";
      window.scrollTo({ top: parseInt(strTop), behavior: "instant" });
    }, 100);
  }
});
